import { render, staticRenderFns } from "./selected-recipe.vue?vue&type=template&id=1f4ed970"
import script from "./selected-recipe.vue?vue&type=script&lang=js"
export * from "./selected-recipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports